import Layout from './widgets/Layout'
import PostView, { PostViewProps } from './views/PostView'
import { DMEAppProps } from './DMEApp'

export interface DMEPostProps extends Pick<DMEAppProps, 'settings'> {
  post: PostViewProps
}

export default function DMEPost({ post, settings }: DMEPostProps) {
  return (
    <Layout settings={settings}>
      <PostView {...post} />
    </Layout>
  )
}
